import {Button, Grid, Typography} from "@material-ui/core";
import EsitoInvioEmailFilter from "./esito-invio-email-filter/EsitoInvioEmailFilter";
import {updateObject} from "../../../../../shared/utils/updateObject";
import {useEffect, useState} from "react";
import {esitoInvioEmailFilter, sortingCriteria} from "./EsitoInvioEmailHelper";
import FilterHistory from "../../../../../shared/components/filter-history/FilterHistory";
import {
    SortingAndButtonsAboveTable
} from "../../../../../shared/components/sorting-and-buttons-above-table/SortingAndButtonsAboveTable";
import GetAppIcon from '@material-ui/icons/GetApp';
import EsitoInvioEmailTable from "./esito-invio-email-table/EsitoInvioEmailTable";
import {useDispatch, useSelector} from "react-redux";
import fileSaver from 'file-saver'
import {toastError, toastWarning} from "../../../../../shared/components/toast/Toast";
import {ESimService} from "../../../../../api/eSimService";
import ButtonWithProgress from "../../../../ui/buttons/button-with-progress/ButtonWithProgress";
import InviaNuovoEmailDialgo from "./invia-nuovo-email-dialog/InviaNuovoEmailDialgo";
import {getEsitoInvioEmailTableData} from "../../../../../store/e-sim/actions";

const EsitoInvioEmail = () => {
    const dispatch = useDispatch()
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId);
    const total = useSelector(state => state.eSimReducer.esitoInvioEmailTableData.total);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [filterHistory, setFilterHistory] = useState(esitoInvioEmailFilter);
    const [areAllSelected, setAreAllSelected] = useState(false);
    const [csvDownloadLoading, setCsvDownloadLoading] = useState(false);
    const [sorting, setSorting] = useState(`${sortingCriteria[0].value},desc`);
    const [selectedRows, setSelectedRows] = useState([])
    const [isInviaNuovoEmailOpen, setIsInviaNuovoEmailOpen] = useState(false)

    const fetchTableData = () => {
        dispatch(getEsitoInvioEmailTableData(filterHistory, sorting, page, rowsPerPage))
    }

    useEffect(() => {
        setSelectedRows([])
        setAreAllSelected(false)
    },[filterHistory]);

    const handleFilterSearch = (name, value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: value
            }
        }))
    };

    const handleFilterSelectsSearch = (value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, value))
    };

    const handleRemoveBadge = (key, type, index) => {
        setPage(0);
        setAreAllSelected(false)
        if (type !== "date") {
            setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
                [key]: {
                    ...currentFilterHistory[key],
                    value: type === "primitive" ? "" : [...currentFilterHistory[key].value].filter((i, idx) => idx !== index)
                }
            }))
        } else {
            setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
                [key]: {
                    ...currentFilterHistory[key],
                    from: null,
                    to: null
                }
            }))
        }
    };

    const handleResetFilter = () => {
        setPage(0);
        setAreAllSelected(false)
        setFilterHistory(esitoInvioEmailFilter);
    };

    const handleSortingChange = (value) => {
        setPage(0)
        setSorting(value)
    };

    const handleAnnullaClick = () => {
        setSelectedRows([])
        setAreAllSelected(false)
    };

    const handleScaricaCsvClick = () => {
        setCsvDownloadLoading(true)
        const sortParts = sorting.split(",")
        ESimService.downloadEsitoInvioEmailCsv(
            integrationId,
            page,
            rowsPerPage,
            sortParts[0],
            sortParts[1],
            filterHistory.idLotto.value,
            filterHistory.numeroTelefono.value,
            filterHistory.numeroTelefono.value,
            filterHistory.email.value,
            filterHistory.seriale.value,
            filterHistory.esitoInvio.value,
            filterHistory.tipoDiRichiesta.value,
            filterHistory.dataInvio.from,
            filterHistory.dataInvio.to
        )
            .then((res) => {
                if (res.status === 204) {
                    console.warn("No data was found to be exported in CSV")
                    toastWarning("Non è stato trovato alcun dato da esportare in CSV")
                    return;
                }
                fileSaver.saveAs(res.data, `esito_invio_email_${new Date().toISOString()}.csv`)
            })
            .catch((e) => {
                toastError('Errore durante il download del file CSV')
                console.log(e);
            })
            .finally(() => {
                setCsvDownloadLoading(false)
            })
    }

    const scaricaButton = (
        <Grid container>
            <ButtonWithProgress
                startIcon={<GetAppIcon/>}
                text="scarica .csv"
                handleClick={handleScaricaCsvClick}
                loading={csvDownloadLoading}
                disabled={total === 0}
                variant="outlined"
            />
            <Button variant='contained'
                    style={{marginLeft: '4px'}}
                    color="primary"
                    onClick={() => setIsInviaNuovoEmailOpen(true)}
                    disabled={!selectedRows.length}>Invia di nuovo</Button>
        </Grid>
    );

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }

    return (
        <>
            <Typography variant="h6"
                        style={{marginBottom: '1em'}}>Esito Invio email</Typography>

            <EsitoInvioEmailFilter handleSearchIcon={handleFilterSearch}
                                   handleSelectSearch={handleFilterSelectsSearch}
                                   filter={filterHistory}/>

            <FilterHistory filter={filterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <SortingAndButtonsAboveTable sortingValue={sorting}
                                         changeSortingCriteria={handleSortingChange}
                                         sortingCriteria={sortingCriteria}
                                         additionalButton={scaricaButton}
                                         hideButton={true}
                                         menuItems={[]}
                                         selectedData={areAllSelected ? selectedRows : selectedRows.length}
                                         handleAnnullaClick={handleAnnullaClick}/>

            <EsitoInvioEmailTable
                selected={selectedRows}
                setSelected={setSelectedRows}
                page={page}
                order={sorting}
                filter={filterHistory}
                sort={sorting}
                rowsPerPage={rowsPerPage}
                handlePaginationChange={handleTablePaginationChange}
                areAllSelected={areAllSelected}
                setAreAllSelected={setAreAllSelected}/>

            {isInviaNuovoEmailOpen ?
                <InviaNuovoEmailDialgo open={isInviaNuovoEmailOpen}
                                       fetchTableData={fetchTableData}
                                       setIsInviaNuovoEmailOpen={setIsInviaNuovoEmailOpen}
                                       selectedRows={selectedRows}
                /> : null}
        </>
    )
};

export default EsitoInvioEmail;
